import React from 'react';
import { Modal, Button, Input, Message, Select, Form } from 'semantic-ui-react';
import { FormRow, FieldLabel } from 'common/styles/page';
import { TimeZones } from 'common/constants/TimeZones';

interface Props {
  open: boolean;
  isEdit: boolean;
  formValue: { name: string; time_zone: string; tier?: number };
  formErrors: any;
  onChange: (field: string, value: string | number) => void;
  onClose: () => void;
  onSubmit: () => void;
}

const TIER_OPTIONS = [
  { key: 1, value: 1, text: 'Tier 1 - Insight' },
  { key: 2, value: 2, text: 'Tier 2 - Improve' },
  { key: 3, value: 3, text: 'Tier 3 - Lead' },
  { key: 4, value: 4, text: 'Tier 4 - Enterprise' },
];

const OrganizationNewModal: React.FC<Props> = ({
  open,
  isEdit,
  formValue,
  formErrors,
  onChange,
  onClose,
  onSubmit,
}) => (
    <Modal open={open} onClose={onClose} size="small" data-testid="admin-organization-modal">
      <Modal.Header data-testid="admin-organization-modal-header">
        {isEdit ? 'Edit Organization' : 'Create New Organization'}
      </Modal.Header>
      <Modal.Content data-testid="admin-organization-modal-content">
        <FormRow>
          <FieldLabel>Organization Name</FieldLabel>
          <Input
            data-testid="admin-organization-name-input"
            type="text"
            value={formValue.name || ''}
            onChange={e => onChange('name', e.target.value)}
            placeholder="Enter Organization Name"
            style={{ width: '100%', marginTop: '8px' }}
          />
          {formErrors?.name && <Message negative content={formErrors.name} />}
        </FormRow>

        <FormRow>
          <FieldLabel>Time Zone</FieldLabel>
          <Select
            data-testid="admin-organization-timezone-select"
            name="time_zone"
            options={TimeZones.map(tz => ({ value: tz.value, text: tz.text }))}
            value={formValue.time_zone}
            onChange={(_, { value }) => onChange('time_zone', value as string)}
            placeholder="Select Time Zone"
            style={{ width: '100%', marginTop: '8px' }}
          />
        </FormRow>

        <FormRow>
          <FieldLabel>Tier</FieldLabel>
          <Select
            data-testid="admin-organization-tier-select"
            name="tier"
            options={TIER_OPTIONS}
            value={formValue.tier}
            onChange={(_, { value }) => onChange('tier', value as number)}
            placeholder="Select Tier"
            defaultValue={1}
            style={{ width: '100%', marginTop: '8px' }}
          />
        </FormRow>
      </Modal.Content>
      <Modal.Actions data-testid="admin-organization-modal-actions">
        <Button data-testid="admin-organization-cancel" onClick={onClose}>
          Cancel
        </Button>
        <Button data-testid="admin-organization-save" primary onClick={onSubmit}>
          {isEdit ? 'Update Organization' : 'Create Organization'}
        </Button>
      </Modal.Actions>
    </Modal>
  );

export default OrganizationNewModal;
